module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    attrs: {
      "id": "info-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message')) + " "), _c('span', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.$t('messageEmail')
    }
  }, [_vm._v(_vm._s(_vm.$t('messageEmail')))])])]), _vm._v(" "), _c('div', {
    staticClass: "privacy-policies"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('privacyPoliciesMsg')))]), _vm._v(" "), _c('router-link', {
    staticClass: "highlighted",
    attrs: {
      "to": "politica"
    }
  }, [_vm._v(_vm._s(_vm.$t('privacyPoliciesLink')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0923294c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home-geolocal/components/info-modal/info-modal.vue
// module id = 286
// module chunks = 0